import { render, staticRenderFns } from "./ManageInvestorsAccountAllTabs.vue?vue&type=template&id=db683d90"
import script from "./ManageInvestorsAccountAllTabs.vue?vue&type=script&lang=js"
export * from "./ManageInvestorsAccountAllTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports